import { render } from "./VSkeleton.vue?vue&type=template&id=744d56c9"
import script from "./VSkeleton.vue?vue&type=script&lang=js"
export * from "./VSkeleton.vue?vue&type=script&lang=js"

import "./VSkeleton.vue?vue&type=style&index=0&id=744d56c9&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__